import { memo } from 'react';

import { ValorantAgentsDisplay } from '@/features/games/valorant/components/valorantAgentsDisplay';
import { Avatar, AvatarImage } from '@/shared/components/ui/avatar';
import { Card } from '@/shared/components/ui/card';

interface DuoActivityAgentsPlayedProps {
  currentUserAgents: { id: string; count: number }[];
  partnerAgents: { id: string; count: number }[];
  currentUserDisplayName: string;
  partnerDisplayName: string;
  currentUserPictureUrl: string;
  partnerPictureUrl: string;
  currentUserFavoriteAgentId: string;
  partnerFavoriteAgentId: string;
}

export const DuoActivityAgentsPlayed = memo(function DuoActivityAgentsPlayed({
  currentUserAgents,
  partnerAgents,
  currentUserDisplayName,
  partnerDisplayName,
  currentUserPictureUrl,
  partnerPictureUrl,
  currentUserFavoriteAgentId,
  partnerFavoriteAgentId,
}: DuoActivityAgentsPlayedProps) {
  return (
    <Card variant="data" className="gap-4">
      <p className="text-cold-300 text-sm leading-5 font-bold">
        Agents played together
      </p>

      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-1.5">
          <Avatar className="size-5">
            <AvatarImage
              src={currentUserPictureUrl}
              alt={currentUserDisplayName}
            />
          </Avatar>
          <p className="text-cold-300 text-xs leading-none font-medium">You</p>
        </div>
        <ValorantAgentsDisplay
          agents={currentUserAgents}
          mainValorantAgentId={currentUserFavoriteAgentId}
        />
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-1.5">
          <Avatar className="size-5">
            <AvatarImage src={partnerPictureUrl} alt={partnerDisplayName} />
          </Avatar>
          <p className="text-cold-300 text-xs leading-none font-medium">
            {partnerDisplayName}
          </p>
        </div>
        <ValorantAgentsDisplay
          agents={partnerAgents}
          mainValorantAgentId={partnerFavoriteAgentId}
        />
      </div>
    </Card>
  );
});
